import React from "react";
import PortaleChildApp from "../../portale-child-app";
import { connect } from "react-redux";

const FinView = ({ workspaceId }) => {
    return (
        <PortaleChildApp
            appId="FIN"
            serviceId="rnd:core:portale-child-apps:fin"
            oneFrontAppId={"mock"} // FIN is not actually a onefront app, but we must treat it as one, so we need to pass a value here
            tenantId={workspaceId}
        />
    );
};

const mapStateToProps = state => ({
    workspaceId: state.services.workspaceId.data ? state.services.workspaceId.data.id : null
});

export default connect(mapStateToProps)(FinView);
